export const replaceSpaceToUpperCase = (item: string) => {
  const changedText = item?.replaceAll(' ', '-');
  return changedText;
};
